import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Bell, Settings, CreditCard, MapPin, LogOut, ChevronRight, ShieldCheck } from 'lucide-react';
import { useStore, logoutClient } from '../lib/store';
export function Profile() {
  const {
    user
  } = useStore();
  const navigate = useNavigate();
  const handleLogout = () => {
    logoutClient();
    navigate('/login');
  };
  return <div className="px-6 pt-12 pb-6 space-y-8" data-id="element-998">
      <h2 className="text-2xl font-semibold text-light" data-id="element-999">Perfil</h2>

      <div className="flex items-center gap-4" data-id="element-1000">
        <div className="w-20 h-20 bg-gold/20 rounded-full flex items-center justify-center text-gold text-2xl font-serif border border-gold/30" data-id="element-1001">
          {user.name ? user.name[0].toUpperCase() : 'U'}
        </div>
        <div data-id="element-1002">
          <h3 className="text-xl font-medium text-light" data-id="element-1003">
            {user.name} {user.lastName}
          </h3>
          <p className="text-sm text-light-muted" data-id="element-1004">{user.email || 'Invitado'}</p>
          <p className="text-xs text-light-muted mt-1" data-id="element-1005">{user.phone}</p>
        </div>
      </div>

      <div className="space-y-2" data-id="element-1006">
        <Link to="/notificaciones" className="flex items-center justify-between p-4 bg-dark-card rounded-2xl border border-white/5 hover:bg-white/5 transition-colors" data-id="element-1007">
          <div className="flex items-center gap-3 text-light" data-id="element-1008">
            <Bell size={20} className="text-gold" data-id="element-1009" /> Notificaciones
          </div>
          <ChevronRight size={16} className="text-light-muted" data-id="element-1010" />
        </Link>
        <div className="flex items-center justify-between p-4 bg-dark-card rounded-2xl border border-white/5 opacity-50" data-id="element-1011">
          <div className="flex items-center gap-3 text-light" data-id="element-1012">
            <MapPin size={20} className="text-gold" data-id="element-1013" /> Direcciones
          </div>
          <ChevronRight size={16} className="text-light-muted" data-id="element-1014" />
        </div>
        <div className="flex items-center justify-between p-4 bg-dark-card rounded-2xl border border-white/5 opacity-50" data-id="element-1015">
          <div className="flex items-center gap-3 text-light" data-id="element-1016">
            <CreditCard size={20} className="text-gold" data-id="element-1017" /> Métodos de pago
          </div>
          <ChevronRight size={16} className="text-light-muted" data-id="element-1018" />
        </div>
        <Link to="/configuracion" className="flex items-center justify-between p-4 bg-dark-card rounded-2xl border border-white/5 hover:bg-white/5 transition-colors" data-id="element-1019">
          <div className="flex items-center gap-3 text-light" data-id="element-1020">
            <Settings size={20} className="text-gold" data-id="element-1021" /> Configuración
          </div>
          <ChevronRight size={16} className="text-light-muted" data-id="element-1022" />
        </Link>
      </div>

      <button onClick={handleLogout} className="w-full flex items-center justify-center gap-2 p-4 text-red-400 bg-red-500/10 rounded-2xl border border-red-500/20 hover:bg-red-500/20 transition-colors font-medium" data-id="element-1023">
        <LogOut size={20} data-id="element-1024" /> Cerrar sesión
      </button>

      {/* Discreet admin entry point */}
      <Link to="/admin" className="flex items-center justify-center gap-2 text-xs text-light-muted hover:text-gold transition-colors pt-2" data-id="element-1025">
        <ShieldCheck size={14} data-id="element-1026" /> Modo Administrador
      </Link>
    </div>;
}